import React from "react";
import { GetSiteData, SiteData } from "../clients/data-service";
import { BasePageProps } from "./BasePageProps";
import { LoadingBlock } from "./LoadingBlock";

class BasePage<T extends BasePageProps> extends React.Component<T, {data?: SiteData}> {
    constructor(props) {
        super(props);
        this.state = {
            data: undefined,
        };

        async function LoadData (comp) {
            const data = await GetSiteData();
            comp.setState(prev => {
                const newState = structuredClone(prev);
                newState.data = data;
                return newState;
            });
        }
        LoadData(this);
    }
    static baserender(siteData: SiteData | undefined, getBody: (siteData: SiteData) => JSX.Element) : JSX.Element {

        if (siteData != null) {
            return getBody(siteData);
        }
        return (<>
            <LoadingBlock />
        </>
        );
    }
}

export default BasePage;